"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "caption1ClassNames", {
    enumerable: true,
    get: function() {
        return _useCaption1Stylesstyles.caption1ClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Caption1"), exports);
const _useCaption1Stylesstyles = require("./useCaption1Styles.styles");
